<template>
    <div>
        <v-flex xs12 v-if="loading == false && !list">
            <v-alert type="error"> Erro ao buscar os condominios. </v-alert>
        </v-flex>
        <v-flex xs12 v-else-if="loading == false && list.length == 0">
            <v-alert type="error"> Nenhum condominio encontrado para gestão. </v-alert>
        </v-flex>
        <v-autocomplete v-else :value="value" @change="$emit('change', $event)" :items="list" :filter="customFilter" item-value="id" item-text="name" :label="title" deletable-chips
            :return-object="returnObject" small-chips :loading="loading" :disabled="loading">
            <template v-slot:item="data">
                <v-list-item-content>
                    <v-list-item-title v-html="data.item.link"></v-list-item-title>
                    <v-list-item-subtitle v-html="data.item.name"></v-list-item-subtitle>
                </v-list-item-content>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            required: true,
        },
        endpoint: {
            type: String,
            default: "api/v2/condominium?sort[name]=ASC",
        },
        returnObject: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "Condomínio",
        },
    },

    data() {
        return {
            list: null,
            loading: true,
        };
    },

    methods: {
        customFilter(item, queryText) {
            const searchText = queryText.toLowerCase();
            return (item.name && item.name.toLowerCase().indexOf(searchText) > -1) || (item.email && item.email.toLowerCase().indexOf(searchText) > -1);
        },
    },

    mounted() {
        this.$http
            .get(this.endpoint)
            .then((result) => {
                if (result) {
                    if (result.condominiuns) {
                        this.list = result.condominiuns;
                    } else {
                        this.list = result;
                    }

                    if (this.list && this.list.length == 1) {
                        this.value = this.list[0]["id"];
                    }
                }
            }).catch(() => {
                this.list = null;
            }).finally(() => {
                this.loading = false;
            });
    },
};
</script>